module.exports = __webpack_public_path__ + "img/speech-bubble.7dda951e.svg";